import React, { Suspense, useState } from 'react';
import { useTranslation } from '../../../tools/i18n';
import ButtonV2 from '../../ButtonV2';
import PictoButton from '../PictoButton';

const DownloadLink = React.lazy(() => import('./DownloadLink'));

interface PrintPDFButtonProps {
  withLabel?: boolean;
}

export default function PrintPDFButton({ withLabel = false }: PrintPDFButtonProps) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <div className={`PrintPDFButton ${withLabel ? 'withLabel' : ''}`}>
      {withLabel ? (
        <ButtonV2
          variant="clear"
          leftIcon="download"
          text={t('travelPlaner.PDF.modal.download')}
          onClick={() => setIsOpen(true)}
          className="PrintPDFButtonAction"
          trackingKey="openPrintPDF_click"
        />
      ) : (
        <PictoButton iconKey="telecharger" onClick={() => setIsOpen(true)} />
      )}
      {isOpen ? (
        <Suspense fallback={null}>
          <DownloadLink onClose={() => setIsOpen(false)} />
        </Suspense>
      ) : null}
    </div>
  );
}
